<template>
  <div>
    <my-head></my-head>
    <div style="border-top: #e5e6eb solid 1px; width: 100%"></div>
    <div class="Details minH">
      <div class="crumbs">
        首页 > 交易服务 >
        <span style="color: #1d2129">交易详情</span>
      </div>

      <div class="details_title">{{ detailPage.name }}</div>

      <div class="flex-between-left">
        <div class="flex-left zhuan_li">
          <img class="icon" src="../assets/Frame-12.png" />
          <div style="margin-right: 8px">项目编号：</div>
          <div style="margin-right: 24px;max-width: 30vw;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ detailPage.code || '' }}</div>
          <div style="margin-right: 8px">挂牌时间：</div>
          <div style="margin-right: 8px">
            {{ detailPage.startTime | dateSy('YYYY年MM月DD日') }}
            至
            {{ detailPage.endTime | dateSy('YYYY年MM月DD日') }}
          </div>
        </div>
        <div class="fen_xiang">
          <i class="el-icon-share"></i>
          分享此项目
        </div>
      </div>

      <div class="jie_shao" style="margin-top: 24px">
        <div>
          <div class="xiang_xi">
            <div
              v-if="getListingDisplayPrice(detailPage) || getListingDisplayPrice(detailPage) === 0"
              class="jia_ge flex-left-center"
            >
              <span>{{ priceCurrencyPrefix(detailPage.foreignType) }} </span>
              {{ getListingDisplayPrice(detailPage) }}
              <span style="margin-left: 6px">万元</span>
            </div>

            <div v-else class="jia_ge flex-left-center">面议</div>

            <div class="biao_qian flex-left">
              <!-- <div class="flex-center" v-show="detailPage.region">
                {{ detailPage.region }}
              </div> -->

              <div
                class="flex-center"
                v-for="(item, index) in propertyCategoryList"
                :key="'category-' + index"
              >
                {{ item }}
              </div>

              <div class="flex-center" v-show="propertyCategoryList.includes('专利')" v-for="(item, index) in typelist"
                :key="index">
                {{ item }}
              </div>

              <div class="flex-center" v-for="(item, index) in projectD" :key="index + 'a'">
                {{ item }}
              </div>

              <div class="flex-center" v-show="detailPage.none">
                {{ detailPage.none }}
              </div>
            </div>

            <div class="xi_jie flex-left flex-wrap">
              <div>
                项目所在国家/地区：
                <span>{{ detailPage.regionName }}</span>
              </div>

              <!-- <div>
                受托机构联系人：
                <span v-if="detailPage.applicantType == '自然人'">
                  {{ detailPage.transferorName }}
                </span>
                <span v-else>
                  {{ detailPage.linkman }}
                </span>
              </div> -->

              <div>
                知识产权类别：
                <span>{{ propertyCategoryDisplay }}</span>
              </div>

              <div>
                交易方式：
                <span>{{ dealWayFullDisplay }}</span>
              </div>
            </div>

            <div style="border-top: 1px solid #e5e6eb; width: 100%"></div>
            <div class="gong_si flex-left-center">
              <!-- <img
                src="http://www.sinoip.net/upload/img/store/slide/zzl0001.jpg"
              /> -->
              <div class="xin_xi flex-left flex-wrap">
                <!-- <div class="flex-left-center">
                  申请人：
                  <span>{{ detailPage.transferorName }}</span>
                </div> -->

                <div>
                  项目联系人：
                  <!-- <span v-if="detailPage.applicantType == '自然人'">
                    {{ detailPage.linkname }}
                  </span>
                  <span v-else>
                    {{ detailPage.linkman }}
                  </span> -->
                  <span>{{ detailPage.xmlxr }}</span>
                </div>

                <div class="flex-left-center">
                  联系人电话：
                  <span>{{
                    detailPage.lxrdh
                  }}</span>
                </div>
              </div>
            </div>
            <div class="flex-between">
              <div class="buttons flex-between">
                <div class="shou_rang flex-center" @click="toAssignment">
                  <img src="../assets/Frame-13.png" alt="" />
                  我要受让
                </div>
                <div class="shou_cang flex-center" @click="collection" v-if="!isCollect">
                  <img src="../assets/收藏.png" alt="" />
                  添加收藏
                </div>
                <div class="shou_cang_yi flex-center" @click="collectionQx" v-else-if="isCollect">
                  <img src="../assets/已收藏.png" alt="" />
                  已收藏
                </div>
              </div>
              <!-- <div class="dian_ji">
                点击次数：
                <span>暂无</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="liu_cheng flex-between">
        <div class="name flex-center">交易流程</div>
        <div class="nei_rong flex-left-center">
          <img src="../assets/lc-1.png" />
          <div>
            <p class="xia_dan">1.在线下单</p>
            <p class="xiang_mu">浏览知识产权项目下单</p>
          </div>
        </div>
        <img class="xia_yi_bu" src="../assets/Line 23.png" />
        <div class="nei_rong flex-left-center">
          <img src="../assets/lc-2.png" />
          <div>
            <p class="xia_dan">2.卖家确认</p>
            <p class="xiang_mu">卖家确认项目和买家交易信息</p>
          </div>
        </div>
        <img class="xia_yi_bu" src="../assets/Line 23.png" />
        <div class="nei_rong flex-left-center">
          <img src="../assets/lc-3.png" />
          <div>
            <p class="xia_dan">3.支付交易款</p>
            <p class="xiang_mu">买家支付，支持多种支付方式</p>
          </div>
        </div>
        <img class="xia_yi_bu" src="../assets/Line 23.png" />
        <div class="nei_rong flex-left-center">
          <img src="../assets/lc-4.png" />
          <div>
            <p class="xia_dan">4.产权交割</p>
            <p class="xiang_mu">产权交割，交易完成</p>
          </div>
        </div>
      </div> -->

      <zr-details :id="$route.query.id" :type="1"></zr-details>
      <el-divider></el-divider>

      <div class="tui_jian_you_zhi">
        <div class="xiang_qing_name">推荐优质项目</div>
        <div class="lie_biao flex-between flex-wrap">
          <list-card :obj="item" v-for="(item, index) in introduction" :key="index"></list-card>
          <div style="width: 31%"></div>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import ListCard from "../components/ListCard.vue";
import { getRequest } from "../api/api";
import { formatDate, priceCurrencyPrefix, getListingDisplayPrice } from "../api/util";
import { getJWT } from "../api/constant";
import ZrDetails from "../components/ZrDetails.vue";

export default {
  name: "Details",
  components: {
    MyHead,
    MyFooter,
    ListCard,
    ZrDetails,
  },
  data() {
    return {
      detailPage: {},
      introduction: [],
      verifi: "", //id
      pingFen: 4.7,
      imgList: [],
      img: "",
      tableData: [
        {
          date: "20200825",
          state: "专利申请权、专利权的转移",
          information: `专利权的转移
IPC(主分类):H01L31/0224
登记生效日:20200805
变更事项:专利权人
变更前权利人:中国科学院苏州纳米技术与纳米仿生研究所
变更后权利人:苏州苏纳光电有限公司
变更事项:地址
变更前权利人:215123 江苏省苏州市工业园区独墅湖高教区若水路398号
变更后权利人:215000 江苏省苏州市工业园区星湖街218号生物纳米园A4楼109C单元`,
        },
        {
          date: "20150916",
          state: "授权",
          information: `授权`,
        },
        {
          date: "20150916",
          state: "实质审查的生效	",
          information: `实质审查的生效
IPC(主分类):H01L31/0224`,
        },
        {
          date: "20150916",
          state: "公开",
          information: `公开`,
        },
      ],
      tableData2: [
        {
          fyje: "¥360.0",
          fyzl: "发明专利第5年年费",
          sjh: `55945249`,
          jfrxx: `中国科学院苏州纳米技术与纳米仿生研究所`,
          jfr: `2016-06-16`,
        },
        {
          fyje: "¥360.0",
          fyzl: "发明专利第4年年费",
          sjh: `55945249`,
          jfrxx: `中国科学院苏州纳米技术与纳米仿生研究所`,
          jfr: `2016-06-16`,
        },
        {
          fyje: "¥5.0",
          fyzl: "印花税",
          sjh: `55945249`,
          jfrxx: `中国科学院苏州纳米技术与纳米仿生研究所`,
          jfr: `2016-06-16`,
        },
      ],
      cardsleft: 0,
      cardwidth: 100,
      isCollect: false, //当前收藏状态
      propertyCategoryList: [], //产权类别列表
      typelist: [], //当产权类别为专利时的专利列表
      projectD: [], //项目领域列表
    };
  },
  computed: {
    dealWayList() {
      if (!this.detailPage.dealWay) return [];
      const isFormalProject =
        this.detailPage.projType === 0 || this.detailPage.projType === "0";
      return [...new Set(String(this.detailPage.dealWay).split(",").filter(Boolean))]
        .filter((item) => !(isFormalProject && item === "许可"));
    },
    dealWayDisplay() {
      return this.dealWayList.join("，");
    },
    dealWayDisplayItems() {
      const items = [...this.dealWayList];
      if (this.detailPage.licenseType) items.push(this.detailPage.licenseType);
      if (this.detailPage.licenseTypeCross) items.push("交叉许可");
      if (this.detailPage.licenseTypeFraction) items.push("分许可");
      if (this.dealWayList.includes("实施许可") && this.detailPage.permission) {
        items.push(this.detailPage.permission);
      }
      if (this.dealWayList.includes("其他") && this.detailPage.dealWayExtra) {
        items.push(this.detailPage.dealWayExtra);
      }
      return items;
    },
    dealWayFullDisplay() {
      return this.dealWayDisplayItems.join("，");
    },
    propertyCategoryDisplay() {
      if (!this.propertyCategoryList.length) {
        return this.detailPage.propertyCategory || "";
      }
      return this.propertyCategoryList
        .map((item) =>
          item === "其他"
            ? this.detailPage.propertyCategoryExtra || item
            : item
        )
        .join("，");
    },
  },
  methods: {
    priceCurrencyPrefix,
    getListingDisplayPrice,
    // 添加收藏
    collection() {
      if (getJWT() && getJWT() != "") {
        getRequest({ url: `/api/v1/user/addCollect?id=${this.verifi}` }).then(
          (res) => {
            if (res.errcode == 200) {
              this.getCollection();
            } else {
              this.$message.error(res.errmsg);
            }
          }
        );
      } else {
        this.$login({
          login: (data) => {
            if (data) {
              this.$store.commit("setUser", data);
              this.getCollection();
            }
          },
        });
      }
    },
    // 取消收藏
    collectionQx() {
      getRequest({ url: `/api/v1/user/deleteCollect?id=${this.verifi}` }).then(
        (res) => {
          if (res.errcode == 200) {
            this.getCollection();
          } else {
            this.$message.error(res.errmsg);
          }
        }
      );
    },
    // 获取当前收藏状态
    getCollection() {
      getRequest({
        url: `/api/v1/markRelease/isCollect?id=${this.verifi}`,
      }).then((res) => {
        if (res.errcode == 200) {
          this.isCollect = res.data;
        }
      });
    },
    // 专利详情
    details() {
      let data = {
        id: this.verifi,
      };
      getRequest({ url: "/api/v1/markRelease/details", data }).then((res) => {
        if (res.errcode == 200) {
          this.detailPage = res.data;
          if (res.data.imageUrl) {
            this.imgList = JSON.parse(res.data.imageUrl);
            this.img = this.imgList[0];
          }
          this.typelist = res.data.patentType
            ? [...new Set(String(res.data.patentType).split(",").filter(Boolean))]
            : [];
          this.propertyCategoryList = res.data.propertyCategory
            ? [...new Set(String(res.data.propertyCategory).split(",").filter(Boolean))]
            : [];

          console.log('this.typelist', this.typelist);
          console.log('res.data.patentType', res.data.patentType);
          this.projectD = res.data.projectDomain
            ? String(res.data.projectDomain).split(",").filter(Boolean)
            : [];
          if (res.data.bdxxs) {
            this.detailPage.bdxxs = typeof res.data.bdxxs === 'string' ? JSON.parse(res.data.bdxxs) : res.data.bdxxs;
          }
        }
      });
    },
    // 专利列表接口
    patentList() {
      getRequest({
        url: `/api/v1/markRelease/recommend?size=9&search=${this.$route.query.tj || ""
          }`,
      }).then((res) => {
        if (res.errcode == 200) {
          this.introduction = (res.data || []).slice(0, 9).map((item) => {
            const currentId = this.detailPage && this.detailPage.id;
            const fromCurrent =
              currentId && item && item.id === currentId
                ? this.detailPage.foreignType || this.detailPage.floorPriceUnit
                : "";
            return {
              ...item,
              foreignType:
                item.foreignType ||
                (item.done && item.done.foreignType) ||
                fromCurrent,
            };
          });
        }
      });
    },
    // 跳转发起受让
    toAssignment() {
      this.$router.push("/details/initiatingassignment?id=" + this.verifi);
    },
    headerClass() {
      return "biao_tou";
    },
    cellClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "jin_e";
      } else if (columnIndex === 2 || columnIndex === 4) {
        return "hui";
      }
    },
    cellClass2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return "hui";
      }
    },
    cardsZ() {
      if (this.cardsleft < 0) {
        this.cardsleft += this.cardwidth;
      }
    },
    cardsY() {
      if (this.cardsleft > -this.cardwidth * (this.imgList.length - 1)) {
        this.cardsleft -= this.cardwidth;
      }
    },
  },
  filters: {
    formatDate(val) {
      return formatDate(val);
    },
  },
  created() {
    this.verifi = this.$route.query.id;
    this.details();
    this.patentList();
    if (getJWT()) {
      this.getCollection();
    }
  },
};
</script>

<style lang="scss">
.eltabs {
  margin-bottom: 54px;

  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__active-bar {
    background-color: #165dff;
    height: 3px;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  .el-tabs__item.is-active {
    color: #165dff;
  }

  .el-tabs__item {
    color: #4e5969;
    font-size: 16px;
    padding: 0;
    font-weight: 500;
    padding-right: 32px;
  }
}

.Details {
  width: 80%;
  margin: 0 auto;

  .tui_jian_you_zhi {
    margin-bottom: 180px;
  }

  .fa_lu_zhuang_tai {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 54px;

    .el-table .jin_e {
      color: #eb5757;
    }

    .el-table .hui {
      color: #86909c;
    }

    .el-table .cell {
      white-space: pre-line;
    }

    .el-table .biao_tou {
      color: #1d2129;
    }

    .el-table--border th.el-table__cell,
    .el-table__fixed-right-patch {
      background: #e5e6eb;
    }
  }

  .zhuan_li_xiang_qing {
    margin-bottom: 54px;

    .zhaun_li_content {
      width: 100%;
      padding: 24px;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      border: 1px solid #e5e6eb;

      .xiang_xi {
        flex: 1;
        font-size: 16px;
        font-weight: 400;
        color: #86909c;
        line-height: 24px;

        .wen_ti {
          width: 18%;
        }

        .da_an {
          width: 32%;
          color: #1d2129;
        }

        &>div {
          p {
            margin: 8px 0;
          }
        }
      }

      .img {
        width: 200px;
        height: 200px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 8px;
        margin-right: 72px;

        img {
          width: 100%;
          max-height: 100%;
        }
      }
    }
  }

  .xiang_mu_xiang_qing {
    margin-bottom: 54px;

    .xiang_qing_content {
      width: 100%;
      padding: 24px;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      border: 1px solid #e5e6eb;
      font-size: 16px;
      font-weight: 400;
      color: #1d2129;
      line-height: 32px;
    }
  }

  .xiang_qing_name {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }

  // .dao_hang {
  //     font-size: 16px;
  //     font-weight: 500;
  //     color: #4e5969;
  //     line-height: 24px;
  //     margin-bottom: 54px;
  //     & > div {
  //         margin-right: 30px;
  //     }
  //     .checked {
  //         color: #165dff;
  //         &::after {
  //             content: '';
  //             display: block;
  //             width: 100%;
  //             margin-top: 8px;
  //             height: 3px;
  //             background: #165dff;
  //         }
  //     }
  // }
  .liu_cheng {
    width: 100%;
    height: 92px;
    background: #f7f8fa;
    border-radius: 8px 8px 8px 8px;
    margin-bottom: 64px;
    padding: 0 24px;

    .xia_yi_bu {
      width: 40px;
    }

    .nei_rong {
      .xiang_mu {
        font-size: 12px;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;
      }

      .xia_dan {
        font-size: 14px;
        font-weight: 500;
        color: #1d2129;
        line-height: 22px;
      }

      img {
        height: 44px;
        margin-right: 12px;
      }
    }

    .name {
      font-size: 18px;
      font-weight: 500;
      color: #1d2129;
      line-height: 28px;
      height: 38px;
      border-right: #e5e6eb solid 1px;
      padding-right: 30px;
    }
  }

  &>.jie_shao {
    margin-bottom: 80px;

    &>div {

      // width: 48%;
      .dian_ji {
        font-size: 12px;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;

        span {
          color: #165dff;
        }
      }

      .buttons {
        width: 240px;
        font-size: 14px;
        font-weight: 500;

        img {
          width: 14px;
          margin-right: 8px;
        }

        .shou_rang {
          background: #165dff;
          color: #ffffff;
        }

        .shou_cang {
          color: #165dff;
        }

        .shou_cang_yi {
          color: #4e5969;
          border: none;
          background: #f2f3f5;
        }

        &>div {
          width: 114px;
          height: 36px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #165dff;
          cursor: pointer;
        }
      }

      .gong_si {
        margin: 24px 0;

        .xin_xi {
          font-size: 14px;
          font-weight: 400;
          color: #86909c;
          line-height: 22px;

          &>div {
            margin-right: 16px;

            span {
              font-size: 16px;
              font-weight: 500;
              color: #1d2129;
              line-height: 24px;
            }
          }
        }

        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 1px solid #e5e6eb;
          margin-right: 12px;
        }
      }

      .xi_jie {
        padding-top: 12px;

        &>div {
          margin-right: 24px;
          font-size: 14px;
          font-weight: 400;
          color: #86909c;
          line-height: 22px;
          margin-bottom: 12px;

          span {
            color: #1d2129;
          }
        }
      }

      .ping_fen {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        margin: 24px 0 12px;
      }

      .biao_qian {
        margin-bottom: 24px;

        &>div {
          height: 24px;
          background: #e8f3ff;
          border-radius: 2px 2px 2px 2px;
          font-size: 12px;
          font-weight: 400;
          color: #165dff;
          padding: 0 12px;
          margin-right: 8px;
        }
      }

      .xiang_xi {
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 24px;

        .jia_ge {
          font-size: 24px;
          font-weight: bold;
          color: #eb5757;
          line-height: 32px;
          margin-bottom: 16px;

          span {
            font-size: 24px;
            margin-right: 4px;
          }
        }
      }

      .list {
        height: 66px;
        overflow: hidden;
        width: 88%;

        .col {
          width: 76px;
          height: 66px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #4e5969;
          margin: 0 12px;
          cursor: pointer;
        }
      }

      .tu_list {
        width: 100%;

        .fan_ye {
          width: 16px;
          height: 48px;
          background: #f2f3f5;
          border-radius: 2px 2px 2px 2px;
          cursor: pointer;
        }
      }

      .tu {
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 20px;
        margin-bottom: 24px;
        // img {
        //   width: 100%;
        // }
      }
    }
  }

  .zhuan_li {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 22px;

    .icon {
      width: 20px;
      margin-right: 8px;
    }
  }

  .fen_xiang {
    font-size: 14px;
    font-weight: 400;
    color: #1d2129;
    cursor: pointer;

    .el-icon-share {
      margin-right: 8px;
    }
  }

  .details_title {
    font-size: 30px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
    margin-bottom: 12px;
  }

  .crumbs {
    font-size: 12px;
    color: #86909c;
    margin-bottom: 32px;
    margin-top: 24px;
  }
}
</style>
